<template>
  <b-form @submit.prevent="onSubmit">

    <b-row align-v="center">
      <b-col lg="4" md="4" v-if="$route.name !== 'CreateUser'">
        <form-group class="col text-right Font" :validations="$v.form.profileImagePreview">
          <div slot-scope="{ errors, invalid }">

            <div id="preview" class="mt-2 text-center  ">
              <img alt="" v-if="form.profileImagePreview" style="object-fit: cover" width="150" height="150" :src="form.profileImagePreview"/>
            </div>

            <label for="profile-image">انتخاب عکس</label>
            <b-form-file
                id="profile-image"
                browse-text="انتخاب عکس"
                @change="onFileChange"
                class="text-center"
                v-model="form.image"
                placeholder="انتخاب عکس"
                drop-placeholder="انتخاب عکس"
            ></b-form-file>

            <input type="hidden" @change="onFileChange"/>


            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </b-col>

      <b-col lg="4" md="4">
        <form-group :validations="$v.form.name">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-1"
                label="نام"
                label-for="input-1"
                description=""
            >
              <b-form-input
                  id="input-1"
                  v-model="form.name"
                  placeholder="نام"
                  :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <b-col lg="4" md="4">
        <form-group :validations="$v.form.last_name">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-6"
                label="نام خانوادگی"
                label-for="input-6"
                description=""
            >
              <b-form-input
                  id="input-6"
                  v-model="form.last_name"
                  type="text"
                  placeholder="نام خانوادگی"
                  :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>
    </b-row>

    <div class="row align-items-center my-3">
      <b-col lg="4" md="4">
        <form-group :validations="$v.form.email">
          <div slot-scope="{ errors, invalid }">

            <div class=" form-group p-0 m-0">
              <label for="">ایمیل</label>
              <span style="cursor: pointer"
                    @click="verifyEmail(user)"
                    v-if="user.email_verified_at == null && $route.name !== 'CreateUser' && isAdmin"
                    class="text-primary">(تایید ایمیل)</span>
              <input class="form-control text-left" v-model="form.email" type="text">
            </div>


          </div>
        </form-group>


        <form-errors-manager :errors="errors"/>
      </b-col>

      <b-col lg="4" md="4">
        <form-group :validations="$v.form.cellphone">
          <div slot-scope="{ errors, invalid }">

            <div class=" form-group p-0 m-0">
              <label for="">تلفن همراه</label>
              <span style="cursor: pointer"
                    @click="verifyCellphone(user)"
                    v-if="user.cellphone_verified_at == null && $route.name !== 'CreateUser' && isAdmin"
                    class="text-primary">(تایید شماره تلفن)</span>
              <input class="form-control" v-model="form.cellphone" type="text">
            </div>

            <form-errors-manager :errors="errors"/>

            <router-link class="text-decoration-none" :to="{name:'VerifiedCellphone'}"
                         v-if="user.cellphone_verified_at == null && $route.name !== 'CreateUser'">
              تایید شماره تلفن با پیامک
            </router-link>

          </div>
        </form-group>
      </b-col>

      <b-col lg="4" md="4">
        <form-group :validations="$v.form.meli_code">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-4"
                label="کدملی"
                label-for="input-4"
            >
              <b-form-input
                  id="input-4"
                  class="text-left"
                  v-model="form.meli_code"
                  :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>

            </b-form-group>
          </div>
        </form-group>
      </b-col>
    </div>

    <b-row align-v="center">


      <b-col lg="4" md="4" v-if="isAdmin  ">
        <form-group :validations="$v.form.role">
          <div slot-scope="{ errors, invalid }">
            <b-form-group id="role" label="نقش" label-for="role">
              <b-form-select
                  :disabled="!isAdmin"
                  v-model="form.role"
                  :options="roles"
              ></b-form-select>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <b-col lg="4" md="4" v-if="isAdmin  ">
        <form-group :validations="$v.form.profile_status">
          <div slot-scope="{ errors, invalid }">
            <b-form-group id="role" label="وضعیت پروفایل" label-for="role">
              <b-form-select
                  v-model="form.profile_status"
                  :options="profile_status"
              ></b-form-select>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <b-col lg="4" md="4" v-if="isAdmin">
        <form-group :validations="$v.form.order_notification">
          <div slot-scope="{ errors, invalid }">
            <b-form-group id="order_notification" label="پیام سفارش جدید" label-for="role">
              <b-form-select
                  v-model="form.order_notification"
                  :options="order_notification"
              ></b-form-select>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>


      <b-col lg="4" md="4" v-if=" $route.name != 'CreateUser'">
        <form-group :validations="$v.form.username">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-4"
                label="نام کاربری"
                label-for="input-4"
            >
              <b-form-input
                  id="input-4"
                  class="text-left"
                  v-model="form.username"
                  :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>

            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <b-col lg="4" md="4" v-if=" $route.name != 'CreateUser'">
        <form-group :validations="$v.form.order">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-4"
                label="ترتیب"
                label-for="input-4"
            >
              <b-form-input
                  id="input-4"
                  class="text-left"
                  v-model="form.order"
                  :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>

            </b-form-group>
          </div>
        </form-group>
      </b-col>


      <b-col lg="4" md="4" class="text-center" v-if="isAdmin && $route.name != 'CreateUser'">
        <panel-manager :user="form"/>
      </b-col>

    </b-row>

    <b-row v-if="$route.name == 'CreateUser' ">
      <b-col lg="4" md="4">
        <form-group :validations="$v.form.password">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-5"
                label="رمز عبور "
                label-for="input-5"
            >
              <b-form-input
                  autocomplete="off"
                  id="input-5"
                  placeholder="رمز عبور "
                  type="password"
                  v-model="form.password"
                  :class="{ invalid }"
              >
              </b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <b-col lg="4" md="4">
        <form-group :validations="$v.form.password_confirmation">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-9"
                label="تکرار رمز عبور "
                label-for="input-9"
            >
              <b-form-input
                  id="input-9"
                  autocomplete="off"
                  type="password"
                  placeholder="تکرار رمز عبور "
                  v-model="form.password_confirmation"
                  :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="4" md="4">
        <form-group :validations="$v.form.public_name">
          <div slot-scope="{ errors, invalid }">
            <label for="">نام نمایشی</label>
            <b-form-group
                id="input-group-24"
                label-for="input-5">
              <b-form-input
                  placeholder="نام نمایشی"
                  type="text"
                  v-model="form.public_name"
                  :class="{ invalid }"
              >
              </b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>

        </form-group>
      </b-col>
      <b-col lg="4" md="4" v-if="isAdmin">

        <div class="">
          <span class="badge badge-primary mx-1" v-for="(item,index) in form.tags"
                @click="removeTag(index)">{{ item.name }}</span>

          <div class="">
            <tag-user @selectedTags="setUserTags"/>
          </div>

        </div>

      </b-col>


      <div v-if="isAdmin && $route.name !== 'CreateUser'" class="col-lg-4 col-md-4">
        <user-access :user="form" v-model="form.user_access"/>
      </div>

      <b-col lg="4" md="4"
             v-if="$route.name !== 'CreateUser' && findAttributeOnSiteInfo('advance_description_on_profile')[0] == ''">
        <form-group :validations="$v.form.description">
          <div slot-scope="{ errors, invalid }">
            <b-form-group id="order_notification" label="توضیحات" label-for="role">
              <b-form-textarea v-model="form.description"></b-form-textarea>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <form-group :validations="$v.form.description" class="col-12">
        <div slot-scope="{ errors, invalid }" class="col-12">
          <advance-description1 v-if="$route.name !== 'CreateUser'"
                                v-model="form.description"
                                class="col-12"
                                :description="form.description"
                                :inputsConfig="findAttributeOnSiteInfo('advance_description_on_profile')[0]"/>
        </div>
      </form-group>

    </b-row>


    <b-row>
      <b-button type="submit" pill variant="purple" class="w-100 mt-4"
      >تایید
      </b-button
      >
    </b-row>
  </b-form>
</template>


<script>
import {mapGetters, mapActions} from "vuex";
import FormGroup from "../../components/validator/FormGroup";
import FormErrorsManager from "../../components/validator/FormErrorsManager.vue";
import {required, requiredIf, email, maxLength, minLength} from "vuelidate/lib/validators";
import {phone} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import {rolesTranslate} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/User";
import PanelManager from "@/plugin/components/dashboard/User/PanelManager.vue";
import TagUser from "@/plugin/components/dashboard/User/TagUser.vue";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import UserAccess from "@/plugin/components/dashboard/User/UserAccess.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import AdvanceDescription1 from "@/plugin/components/dashboard/AdvanceDescription/AdvanceDescription1.vue";

export default {
  name: "ProfileComponent",
  props: {
    user: {},
    submit: {},
  },
  components: {AdvanceDescription1, UserAccess, TagUser, PanelManager, FormGroup, FormErrorsManager},
  data() {
    return {
      rolesTranslate,
      form: {
        id: '',
        name: '',
        last_name: '',
        order_notification: '',
        email: '',
        email_verified_at: '',
        role: '',
        cellphone: '',
        meli_code: '',
        cellphone_verified_at: '',
        image: null,
        description: null,
        type: 1,
        public_name: "",
        tags: [],
        profile_status: 0,
        order: 1,
        user_access: [],
        username: ''
      },
      roles: [
        {text: "کاربر عادی", value: 0},
        {text: "مدیر سایت", value: 1},
        {text: "فروشگاه", value: 2},
        {text: "ویرایشگر", value: 3},
        {text: "نویسنده", value: 4},
        {text: "مدیریت سفارشات", value: 5},
      ],
      order_notification: [
        {text: "غیرفعال", value: 0},
        {text: "فعال", value: 1},
      ],
      profile_status: [
        {text: "غیرفعال", value: 0},
        {text: "فعال", value: 1},
      ],
    }
  },
  methods: {
    findAttributeOnSiteInfo,
    ...mapActions({
      sendCellPhoneVerificationCode: "Authentication/sendCellPhoneVerificationCode",
    }),
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    setUser() {
      if (this.$route.name !== 'CreateUser') { // only in update and profile section we fill form with user.prop
        this.form = Object.assign({}, this.user)
        this.form.profileImagePreview = this.form.image
        this.form.user_access = this.user?.meta?.find(item => item.name == 'user_access')

        let userCombinationRole = `${this.user.role}-${this.user.type}`
        let userRoleKeyOnTranslation = Object.keys(this.rolesTranslate).indexOf(userCombinationRole)


        userRoleKeyOnTranslation = userRoleKeyOnTranslation > 1 ? userRoleKeyOnTranslation : this.form.role;

        this.form.role = userRoleKeyOnTranslation
        this.form.image = null
      } else {
        this.form.profileImagePreview = ''
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.image = file;
      this.form.profileImagePreview = URL.createObjectURL(file);
    },
    async onSubmit() {
      if (this.invalid()) {

        if (this.form.panels != null && !Array.isArray(this.form.panels)) {
          this.form.panels = [this.form.panels]
        } else {
          delete this.form.panels
        }
        console.log(this.form)
        await this.submit(this.form);
      }
    },
    setUserTags(data) {
      let tags = data.tags;

      if (this.form.tags.length == 0) {
        this.form.tags.push(tags)
      } else {
        if (this.form.tags.indexOf(tags) == -1) {
          this.form.tags.push(tags)
        }
      }

    },
    removeTag(index) {
      if (confirm('ایا از حذف اطمینان دارید؟')) {
        this.form.tags.splice(index, 1)
      }
    },
    async verifyCellphone(user) {
      this.$store.dispatch('User/verifyCellphoneFromAdmin', user).then((response) => {
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        this.$emit('userUpdate', true)
      })
    },
    async verifyEmail(user) {
      this.$store.dispatch('User/verifyEmailFromAdmin', user).then((response) => {
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        this.$emit('userUpdate', true)
      })
    },
  },
  validations() {
    if (this.$route.name == 'CreateUser') {

      return {

        form: {
          name: {required},
          last_name: {required},
          cellphone: {required, phone},
          email: {
            required: requiredIf(function () {
              return this.form.email != null && this.form.email != "";
            }),
            email,
          },
          role: {required},
          order_notification: {required},
          password: {required},
          password_confirmation: {required},
          description: {},
          profileImagePreview: {},
          username: {},
          public_name: {},
        }
      }
    }

    return {
      form: {
        name: {required},
        last_name: {required},
        cellphone: {required, phone},
        meli_code: {maxLength: maxLength(10), minLength: minLength(10)},
        role: {required},
        description: {},
        public_name: {},
        order: {required},
        profileImagePreview: {},
        order_notification: {required},
        profile_status: {},
        username: {},
        email: {
          required: requiredIf(function () {
            return this.form.email != null && this.form.email != "";
          }),
          email,
        },
      }
    }

  },
  computed: {
    ...mapGetters({
      isPhoneVerified: "User/isPhoneVerified",
      isAdmin: "User/isAdmin",
      profile: "User/getProfile",
    }),
  },
  mounted() {
    this.setUser();
  },
  watch: {
    user: function () {
      this.setUser();
    },
  },
};
</script>

<style scoped>
</style>